import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../../constants'
import { ModalStatusEvent } from '../../base'
import { Locale } from '../../../modules/locale'
import { ISearchConfig } from '../../../modules/search'
import { SearchBarSubscriber } from '../../../modules/search/SearchBarSubscriber'
import { Font } from '../../../constants'
import MainModule from '../../../modules/main'
import { Autocomplete } from '../../../modules/autocomplete'
import { inlineStyle } from '../../../modules/utils'
import { Callback } from '../../../modules/callback'

Locale.getInstance().registerKeySet('fr', 'searchBar', {
  searchPlaceholder: 'Rechercher',
  searchPlaceholderMobile: 'Rechercher',
  autocompleteTitle: 'Recherches suggérées',
  eventOffers: 'Événement',
  artist: 'Artiste',
  organization: 'Organisation',
  places: 'Lieu',
  festival: 'Festival',
})

Locale.getInstance().registerKeySet('en', 'searchBar', {
  searchPlaceholder: 'Search for an event, artist or venue',
  searchPlaceholderMobile: 'Search',
  autocompleteTitle: 'Suggested searches',
  eventOffers: 'Event',
  artist: 'Artist',
  organization: 'Organization',
  places: 'Place',
  festival: 'Festival',
})

export class LvcSearchSuggestion extends MinzeElement {
  attrs = ['data-group-id', 'data-value', 'on-click']
  reactive: Reactive = [['autocompleteItemType', '']]

  static observedAttributes = ['data-value']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'data-value') {
      let autocompleteItemString = decodeURIComponent((newValue ?? '') as string)
      let autocompleteItem = JSON.parse(autocompleteItemString)
      this.autocompleteItemType = this.getCorrectAutocompleteItemType(autocompleteItem.type)
    }
  }

  getCorrectAutocompleteItemType(itemType: string): string {
    // Item type is a string that can be either "eventOffers", "contributors" or "places"
    // so we need to return the correct name according to the language
    let correctType = ''

    itemType = itemType.toLowerCase()

    switch (itemType) {
      case 'eventoffers':
        return (correctType = Locale.getInstance().getKey('searchBar.eventOffers'))
      case 'person':
        return (correctType = Locale.getInstance().getKey('searchBar.artist'))
      case 'organization':
        return (correctType = Locale.getInstance().getKey('searchBar.organization'))
      case 'places':
        return (correctType = Locale.getInstance().getKey('searchBar.places'))
      case 'festival':
        return (correctType = Locale.getInstance().getKey('searchBar.festival'))
      default:
        return (correctType = '')
    }
  }

  onButtonClick(event: any): void {
    Callback.call(this.onClick as string, this.dataValue ?? '')
  }

  html = () => `
    <button class="autocomplete-drawer-item" data-value="${this.dataValue}">
      <slot>
      </slot><span class="autocomplete-drawer-type">${this.autocompleteItemType}</span>
    </button>
  `

  css = () => `
      :host {
        display: flex;
        padding: 0px 10px;
      }
      button {
        flex: 1;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
        color: var(--brand-minuit, #1E007D);
        font-family: ${Font.family};
        font-size: 14px;
        font-weight: ${Font.weight.medium};
        line-height: 1.2;
        display: flex;
        text-align: left;
        align-items: center;
        padding-left: 0px;
        justify-content: space-between;
        height: 44px;
      }

      .autocomplete-drawer-type{
        font-size: 14px;
        font-weight: normal;
        color: #1e007da6;
        font-style: italic;
      }

      lvc-search-two-icon {
        margin-right: 10px;
        height: 24px;
      }

      .autocomplete-drawer {
        display: none;
      }

      .autocomplete-drawer.show {
        display: block;
      }

      slot {
        display: flex;
        align-items: center;
        gap: 10px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

  `

  eventListeners: EventListeners = [[this, 'click', this.onButtonClick.bind(this)]]
}
